import { render, staticRenderFns } from "./UseBonus.vue?vue&type=template&id=0b2e56d8&scoped=true&"
import script from "./UseBonus.vue?vue&type=script&lang=js&"
export * from "./UseBonus.vue?vue&type=script&lang=js&"
import style0 from "./UseBonus.vue?vue&type=style&index=0&id=0b2e56d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2e56d8",
  null
  
)

export default component.exports